import { HtmlHTMLAttributes, useCallback, useContext, useEffect, useState } from "react";
import { Administrador, Modulos, Padrão, UsuarioInput, getCategoriaIndexByName } from "../../../services/UsuarioService";

import Button from "../../../components/button/button";
import Spinner from "../../../components/spinner/spinner";
import UsuarioAcesso from "../usuario-acesso/usuario-acesso";
import Modal from "../../../components/modal/modal";
import SessaoUsuarioContext from "../../../contexts/SessaoUsuarioContext";
import Feedback from "../../../components/feedback/feedback";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGear } from "@fortawesome/free-solid-svg-icons";

import "./usuario-formulario.css";
import "../usuario-edicao/usuario-edicao.css";
import useAppFeedback from "../../../hooks/use-app-feedback";
interface UsuarioFormProps extends HtmlHTMLAttributes<HTMLElement> {
  classes?: string,
  loading: boolean;
  titulo?: string;
  usuarioInput?: UsuarioInput;
  acao: {
    onClickAcao?: (value: UsuarioInput) => Promise<boolean>,
    texto: string
  };
  cancelarAcao?: {
    onClickCancelaAcao?: () => void
    texto: string
  }
}

const UsuarioForm = ({ loading, acao, cancelarAcao, classes, titulo, usuarioInput }: UsuarioFormProps) => {

  const { sessao } = useContext(SessaoUsuarioContext);
  const [isOpened, setIsOpened] = useState<boolean>(false);
  const [nome, setNome] = useState("");
  const [email, setEmail] = useState("");
  const [areas, setAreas] = useState([]);
  const [paineis, setPaineis] = useState([]);
  const [categoria, setCategoria] = useState("");
  const [usuario, setUsuario] = useState({});
  const { feedbacks, removerFeedback, limparFeedbacks } = useAppFeedback();
  const [definiModuloAcesso, setDefiniModuloAcesso] = useState<number>(1);
  const [_loading, setLoading] = useState(false);
  const [statusModulos, setStatusModulos] = useState<{ [key: string]: boolean }>({
    pessoal: false,
    rh: false
  });

  const obtemCategoriaDefault = () => {
    var categoriaEnum = getCategoriaIndexByName(categoria);
    return (categoriaEnum === Administrador ? "Administrador" : (categoriaEnum === Padrão ? "Padrão" : ""));
  }

  const atulizarStatusModulos = (status: boolean, nomeDoModulo: string) => {
    setStatusModulos(beforeValue => ({
      pessoal: (nomeDoModulo?.toLowerCase() === "pessoal" ? status : beforeValue?.pessoal),
      rh: (nomeDoModulo?.toLowerCase() === "rh" ? status : beforeValue?.rh)
    }));
  };

  const clearForm = useCallback(() => {
    setEmail("");
    setNome("");
    setCategoria("");
    setStatusModulos({
      pessoal: false,
      rh: false,
    });
  }, []);

  useEffect(() => {
    setLoading(true);
    const usuario = {
      id: usuarioInput?.id,
      nome: nome,
      email: email,
      categoria: categoria,
      statusModulos: statusModulos,
      paineisLiberados: paineis,
      areaLiberadas: areas
    }
    setUsuario(usuario)

    setLoading(false);
  }, [nome, email, categoria, statusModulos, usuarioInput, paineis, areas])

  useEffect(() => {
    setEmail(usuarioInput?.email ?? "");
    setNome(usuarioInput?.nome ?? "");
    setCategoria(usuarioInput?.categoria ?? "Padrão");
    setStatusModulos({
      pessoal: usuarioInput?.statusModulos.pessoal || false,
      rh: usuarioInput?.statusModulos.rh || false,
    });
    setPaineis(usuarioInput?.paineisLiberados || []);
    setAreas(usuarioInput?.areaLiberadas || []);
  }, [usuarioInput]);

  const onChangeAcess = (modulo: any) => {
    limparFeedbacks();
    setDefiniModuloAcesso(modulo)
    setIsOpened(true);
  }

  const CloseModal = () => {
    setIsOpened(false);
  }

  const ObtemAreasEPaineisEscolhidos = (Areas: [], Paineis: []) => {
    setAreas(Areas);
    setPaineis(Paineis);
    setIsOpened(false);
  }

  return (
    <>
      <div className={`formulario__usuario ${classes}`}>
        <Feedback feedbacks={feedbacks} remover={removerFeedback} />
        {titulo && <h1 className='formulario__titulo'>{titulo}</h1>}
        <label>Preencha os campos abaixo para criar um novo usuário</label>

        <div className='corpo'>
          <div className="formulario__colunas">
            <label htmlFor="form-usuario-nome">Nome*</label>
            <input
              id="form-usuario-nome"
              maxLength={150}
              className='formulario__corpo--input'
              onChange={x => setNome(x.target.value)}
              value={nome}></input>
          </div>

          <div className="formulario__colunas">
            <label htmlFor="form-usuario-email">E-mail*</label>
            <input
              id="form-usuario-email"
              maxLength={150}
              className='formulario__corpo--input'
              readOnly={!!usuarioInput?.id}
              style={{ color: usuarioInput?.id ? 'gray' : 'black' }}
              onChange={x => setEmail(x.target.value)}
              value={email}></input>
          </div>
          <div className="formulario__colunas">
            <label htmlFor="form-usuario-categoria">Perfil de usuário*</label>
            <select id="form-usuario-categoria" className="formulario__corpo--select"
              onChange={x => setCategoria(x.target.value)}
              value={obtemCategoriaDefault()}>
              <option defaultChecked value="Padrão">Padrão</option>
              <option value="Administrador">Administrador</option>
            </select>
          </div>
        </div>

        <fieldset style={{ borderRadius: '10px', border: '1px solid #ccc', background: '#F7F8F9', marginBottom: '20px' }}>
          <h2 className='formulario__titulo'> Visualizar </h2>
          {(() => {
            return sessao?.modulosLiberados.map(modulo => (
              <div className="row" key={modulo.nome}>
                <input
                  style={{ marginRight: '10px' }}
                  id={`form-modulo-${modulo.nome}`}
                  name={modulo.nome?.toLowerCase()}
                  type="checkbox"
                  value={modulo.nome}
                  checked={statusModulos[modulo.nome?.toLowerCase()]}
                  onChange={x => atulizarStatusModulos(x.target.checked, x.target.value)} />

                <label htmlFor={`form-modulo-${modulo.nome}`} style={{ width: '120px' }}>
                  Módulo {modulo.nome === "Rh" ? "RH" : modulo.nome}</label>
                {
                sessao.validaAreasOrganizacionais &&
                  <fieldset className={`ms-trigger--form ${modulo.nome === "Rh" ? 'ms-disabled' : ''}`}
                    style={{ marginLeft: '8px', padding: '0px', borderRadius: '4px', border: '1px solid #ccc', background: '#DCDFE4' }}>
                    <label
                      className={`ms-trigger--form ${!statusModulos[modulo.nome?.toLowerCase()] ? 'is-disabled' : ''}`}
                      onClick={() => onChangeAcess(Modulos[modulo.nome as keyof typeof Modulos])}>
                      <FontAwesomeIcon icon={faGear} style={{ marginRight: '3px' }} />
                      Definir acesso
                    </label>
                  </fieldset>
                }
              </div>
            ))
          })()}
        </fieldset>

        {<Modal isOpened={isOpened}>
          <UsuarioAcesso
            cancelaAcesso={CloseModal}
            moduloEscolhido={definiModuloAcesso}
            retornaAcessos={ObtemAreasEPaineisEscolhidos}
            listaDeAcessos={{
              areasEscolhidas: areas,
              paineisEscolhidos: paineis
            }}
          />
        </Modal>}

        <Button
          classes='formulario__button--cancelar'
          style={{ marginLeft: 0 }}
          text={cancelarAcao!.texto}
          onClick={() => cancelarAcao!.onClickCancelaAcao && cancelarAcao!.onClickCancelaAcao()} />
        {
          acao &&
          <Button
            classes='formulario__button'
            style={{ margin: 8 }}
            text={acao.texto}
            onClick={async () => acao.onClickAcao && await acao.onClickAcao(usuario as UsuarioInput) && clearForm()} />
        }
      </div>
      {
        _loading && <div className='loading'>
          <Spinner size={170} />
        </div>
      }
    </>
  );
}

export default UsuarioForm;
